module.exports = __webpack_public_path__ + "media/images/product-img-04-293040ed66aeba8d9ccdf1e7714dec95.png";